/**
 * 表单验证
 * created by mr.x on 16/04/18.
 * @import common/fx.common.js
 *
 * @container                 object	            (必须)验证表单对象,支持css选择器		          			默认 null
 * @type					  string				(必须)验证类型,多个类型以|分割							默认 required
 * @number               	  number      			(可选)小数点位数（仅当验证小数生效）				        默认 null
 * @isMust               	  boolean      			(可选)是否必须验证										默认 true
 * @success                	  function            	(可选)验证成功回调
 * @error                     function            	(可选)验证失败回调
 *

 * ''again''  			  	  与某个input值是否相同
 * ''required''  			  非空
 * ''ACSII''  				  仅ACSII字符
 * ''number''  				  纯数字，不能包含任何非数字
 * ''integer''  			  正负整数
 * ''negativeInteger''  	  负整数
 * ''positiveInteger''  	  正整数
 * ''float''  				  正负浮点数
 * ''negativeFloat''  		  负浮点数
 * ''positiveFloat''  		  正浮点数
 * ''alphabet''  			  大小写字母
 * ''LETTER''  				  大写字母
 * ''letter''  				  小写字母
 * ''chinese''  			  中文
 * ''color''  				  16进制色值
 * ''date''  				  日期
 * ''card''  				  验证国内银行卡号
 * ''username''  			  用户名
 * ''password''  			  密码
 * ''trueName''  			  真实姓名
 * ''tellphone''  			  手机号码
 * ''phoneNumber''  		  包括验证国内区号,国际区号,分机号
 * ''email''  				  邮箱
 * ''QQ''  					  QQ
 * ''IDcard''  				  身份证
 * ''IP''  					  IP地址
 * ''postCode''  			  邮政编码
 * ''img''  				  图片
 * ''file''  				  判断压缩文件
 * ''site'' 				  网址
 * ''ftp''  				  ftp地址
 * ''passport''  			  护照号码
 * ''driver''  				  驾驶证
 * ''ccv''  				  验证CCV
 * ''creditCard''  			  验证信用卡
 * ''usaCreditCard''  		  验证美国信用卡
 * ''usaPostCard''  		  验证美国邮政编码
 */

const reg = (nu: any) => ({
  price: /^([1-9]\d+|\d)(\.\d{1,2})?$/,
  required: /\S+/,
  ACSII: /^[\x00-\xFF]+$/,
  number: /^([+-]?)\d*\.?\d+$/,
  integer: /^-?[1-9]\d*$/,
  negativeInteger: /^-[1-9]\d*$/,
  positiveInteger: /^[0-9]\d*$/,
  float: /^-?(([1-9]\d+|\d)(\.\d{1,})?)$/,
  negativeFloat: new RegExp('^-(([1-9]\\d+|\\d)(\\.\\d{1,' + (jQuery.isNumeric(nu) ? nu : '') + '})?)$'),
  positiveFloat: new RegExp('^([1-9]\\d+|\\d)(\\.\\d{1,' + (jQuery.isNumeric(nu) ? nu : '') + '})?$'),
  alphabet: /^[A-Za-z]+$/,
  LETTER: /^[A-Z]+$/,
  letter: /^[a-z]+$/,
  chinese: /^[\u4e00-\u9fa5]+$/,
  color: /^#[a-fA-F0-9]{6}$/,
  date: /^\d{4}(\-|\/|.)\d{1,2}\1\d{1,2}$/,
  username: /^[A-Za-z0-9_\-\u4e00-\u9fa5]+$/,
  password: /^[!"#$%&'()*+,\-.:;<=>?@\[\\\]^_`{|}~A-Za-z0-9]{6,20}$/,
  trueName: /^[?!$%~_#`.·@^\u4e00-\u9fa5]+$/,
  tellphone: /^1[3|4|5|7|8][0-9]\d{8}$/,
  phoneNumber: /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/,
  email: /\w+((-w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+/,
  QQ: /^[1-9]*[1-9][0-9]*$/,
  // IDcard: { 15: /^(\d{6})()?(\d{2})(\d{2})(\d{2})(\d{3})$/, 18: /^(\d{6})()?(\d{4})(\d{2})(\d{2})(\d{3})([0-9xX])$/ },
  IP: /((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))/,
  postCode: /^[0-9]{6}$/,
  img: /(.*)\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/,
  file: /(.*)\.(rar|zip|7zip|tgz)$/,
  site: /[a-zA-z]+:\/\/[^\s]+/,
  ftp: /ftp\:\/\/[^:]*:@([^\/]*)/,
  passport: /^[0-9]{9}$/,
  driver: /\d{15}$/,
  ccv: /^[0-9]{3}$/,
  creditCard: /^(4\\d{12}(?:\\d{3})?)$/,
  usaCreditCard: /^[3-6]\d{14,15}$/,
  usaPostCard: /^\d{5}$|^\d{9}$/,
  any: /.*/
  // area: { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
})

export type valueType = keyof ReturnType<typeof reg>

export default function valid(value: any, type: valueType, nu?: number) {
  return reg(nu)[type].test(value)
}



// WEBPACK FOOTER //
// ./src/utils/valild.ts